var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecreased({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30901 16.5486L6.83398 16.9635L6.35896 16.5486C2.36437 13.0596 0.333984 10.0132 0.333984 7.33532C0.333984 3.54307 3.29297 0.833496 6.83398 0.833496C10.375 0.833496 13.334 3.54307 13.334 7.33532C13.334 10.0132 11.3036 13.0596 7.30901 16.5486ZM1.77734 7.33518C1.77734 9.39353 3.44323 11.9829 6.8329 15.0387C10.2226 11.9829 11.8885 9.39353 11.8885 7.33518C11.8885 4.37078 9.60326 2.2782 6.8329 2.2782C4.06254 2.2782 1.77734 4.37078 1.77734 7.33518ZM3.51172 7.04621V8.43326H10.4451V7.04621H3.51172Z",
    fill: "#00A4A4",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecreased);
export default __webpack_public_path__ + "static/media/decreased.9c9f6f3f283d13b12dc1ebfe12face32.svg";
export { ForwardRef as ReactComponent };